import { toFilterEntries } from '../../shared/utils/mapPage';

const fixOldParams = s => s.replace(/%3A/gm, ':');

const getArrayQueryParameters = (param, decode = false) => {
  if (!param) return [];
  if (Array.isArray(param)) {
    if (decode) return param.map(p => fixOldParams(p));
    else return param;
  }
  if (decode) return [fixOldParams(param)];
  return [param];
};

// http://localhost/depi/mediathek?endDate&openSection=Brosch%C3%BCren+und+Flyer&selectedTags=Thema%253ALagerung&startDate

export const restoreQueryParameters = query => {
  const { filters, q, groupFilters, selectedTags, ...restQuery } = query;
  const queryFilters =
    (filters && getArrayQueryParameters(filters)) ||
    (selectedTags && getArrayQueryParameters(selectedTags, true));
  return {
    query: q,
    groupFilters: getArrayQueryParameters(groupFilters),
    filters: queryFilters,
    attributeFilters: restQuery,
  };
};

export const getLabelFromTag = tag => tag.substr(tag.indexOf(':') + 1);

export const filterData = (tags, types) => p => {
  const hasTag = tags.some(f => p.tags.indexOf(f) > -1);
  const hasType = types.some(t => p.type === t);
  return hasType && hasTag;
};

export const groupByTag = tag => p => {
  const filterdTags = p.tags.filter(t => t.includes(tag));
  return getLabelFromTag(filterdTags[0]);
};

export const duplicatePagesWithTag = (tag, pages) => {
  return pages.reduce((acc, p) => {
    const duplications = p.tags.filter(t => t.includes(tag));
    const page = { ...p, tags: p.tags.filter(t => !t.includes(tag)) };
    duplications.forEach(t => {
      acc.push({ ...page, tags: [...page.tags, t] });
    });
    return acc;
  }, []);
};

const DEFAULT_ACCESSOR = 'asList';

const getTagsFilter = context => {
  switch (context) {
    case 'hackschnitzel':
      return ['Seite:Hackschnitzel'];
    case 'pellets':
      return ['Seite:Pellets'];
    case 'holzbriketts':
      return ['Seite:Briketts'];
    default:
      return [];
  }
};

export const getInitialProps = (tags, types, options = {}) => async ({
  query,
  dataStore,
  uiStore,
  ...rest
}) => {
  const { accessor } = options;
  const tagsFilter = getTagsFilter(uiStore.context);
  await dataStore.pages.loadAllPages(tagsFilter);
  const data = dataStore.pages[accessor || DEFAULT_ACCESSOR]
    .map(toFilterEntries)
    .filter(filterData(tags, types));
  const queryParams = restoreQueryParameters(query);
  return { ...queryParams, data };
};

export const getLabel = (key, labels) => {
  if (!labels) return key;
  const label = labels[key];
  if (Array.isArray(label)) {
    return label[0];
  }
  return label;
}

export const getPlainTextLabel = (key, labels) => {
   if (!labels) return key;
  const label = labels[key];
  if (Array.isArray(label)) {
    return label[1];
  }
  return label; 
}
